export default __webpack_public_path__ + "static/redes-twitter-76522aa8065b9d3dbd3cdee999a3c246.jpg";